import { z } from "zod";
import { schemes } from "../../schema-validation";
import { TransactionEventStatus } from "../TransactionEventStatus";

export const transactionEventSchema = z.object({
  return_code: z.string().optional(),
  status: z.nativeEnum(TransactionEventStatus),
  status_detail: z.string().optional(),
  transactionEventID: schemes.uuid(),
  odo_transaction_event_id: schemes.uuid(),
  timestamp: z.date(),
});

export type TTransactionEvent = z.infer<typeof transactionEventSchema>;
